import { DroppsProduct } from "@/store";
import { PortalAd } from "./types";

const dishAd = {
  title: "Goodbye Grease, Hello Sparkle",
  description:
    "Stubborn grease & stuck-on food doesn't stand a chance against our UltraWash Dish Detergent. Get the biobased clean you love for all your dishes & glassware.",
  name: "dish_upsell",
  image: {
    desktop: {
      src: "//cdn.shopify.com/s/files/1/0268/4219/files/hero-portal-dish_ad-750px.jpg?v=1727197649",
      alt: "Dish upsell background Image",
    },
    mobile: {
      src: "//cdn.shopify.com/s/files/1/0268/4219/files/hero-portal-dish_ad-750px.jpg?v=1727197649",
    },
  },
  initialFilter: "Dishwasher Detergent Pods",
};

const laundryAd = {
  title: "We Can Handle <br> Your Dirtiest Laundry",
  name: "laundry_upsell",
  description:
    "Stinky sweat & stubborn spaghetti stains are no match for our cutting-edge Odor + Stain Laundry Detergent. This powerful, biobased formula keeps clothes clean & fresh.",
  image: {
    desktop: {
      src: "//cdn.shopify.com/s/files/1/0268/4219/files/hero-portal-laundry_ad-750px.jpg?v=1727197648",
      alt: "Laundry upsell background Image",
    },
    mobile: {
      src: "//cdn.shopify.com/s/files/1/0268/4219/files/hero-portal-laundry_ad-750px.jpg?v=1727197648",
    },
  },
  initialFilter: "Stain & Odor Laundry Detergent Pods",
};

const ultrawashPlusUpgradeAd = {
  title: "Dish Duty Just Got Easier",
  name: "ultrawash_plus_upsell",
  description:
    "Level up your grease-blasting, food-fighting power with new triple-action UltraWash Plus—it's the ultimate clean for dishes & glassware.",
  image: {
    desktop: {
      src: "//cdn.shopify.com/s/files/1/0268/4219/files/hero-portal-uwplus_ad-750px.jpg?v=1727191772",
      alt: "Ultrawash plus upsell background Image",
    },
    mobile: {
      src: "//cdn.shopify.com/s/files/1/0268/4219/files/hero-portal-uwplus_ad-750px.jpg?v=1727191772",
    },
  },
  initialFilter: "Ultrawash Plus",
};

const addUltrawashPlusAd = {
  title: "A Triple Win For Dishes",
  name: "ultrawash_plus_upsell",
  description:
    "Multiply your cleaning power with UltraWash Plus, formulated with fast-acting enzymes, grease-cutting surfactants & a spot-free rinse aid for sparkling dishes.",
  image: {
    desktop: {
      src: "//cdn.shopify.com/s/files/1/0268/4219/files/hero-portal-uwplus_ad-750px.jpg?v=1727191772",
      alt: "Ultrawash plus upsell background Image",
    },
    mobile: {
      src: "//cdn.shopify.com/s/files/1/0268/4219/files/hero-portal-uwplus_ad-750px.jpg?v=1727191772",
    },
  },
  initialFilter: "Ultrawash Plus",
};

const oxiBoosterAd = {
  title: "Boost Brights, Whiten Whites",
  description:
    "Our blend of six enzymes break down tough stains, while whitening and brightening fabrics to restore their vibrancy and reduce pilling.",
  name: "oxi_upsell",
  image: {
    desktop: {
      src: "//cdn.shopify.com/s/files/1/0268/4219/files/oxi_booster_ad.jpg?v=1727191772",
      alt: "Oxi upsell background image",
    },
    mobile: {
      src: "//cdn.shopify.com/s/files/1/0268/4219/files/oxi_booster_ad.jpg?v=1727191772",
    },
  },
  initialFilter: "Oxi Booster Pods",
};

export const getAd = (subProducts: DroppsProduct[]): PortalAd | null => {
  const containsDish = subProducts.some((p) =>
    p.title.includes("Dishwasher Detergent Pods")
  );

  const containsLaundry = subProducts.some((p) =>
    p.title.includes("Laundry Detergent")
  );

  const containsOxi = subProducts.some((p) => p.id === 294393315355);

  // boxes contain laundry and dish, but not oxi -> upsell oxi
  if (containsLaundry && containsDish && !containsOxi) {
    return oxiBoosterAd;
  }

  // boxes contain laundry, but not dish -> upsell dish
  if (containsLaundry && !containsDish) {
    return dishAd;
  }

  // boxes contain dish, but not laundry -> upsell laundry
  else if (containsDish && !containsLaundry) {
    return laundryAd;
  }

  // boxes contain laundry and dish and oxi -> no need to upsell
  else return null;
};

export const getUltrawashAd = (
  subProducts: DroppsProduct[]
): PortalAd | null => {
  const constainsUltrawashPlus = subProducts.some((p) =>
    p.tags.includes("ultrawash-plus")
  );

  const containsDish = subProducts.some((p) =>
    p.tags.includes("Dishwasher Detergent Pods")
  );

  // boxes has ultrawash plus -> no need to upsell
  if (constainsUltrawashPlus) {
    return null;
  }

  // boxes contains ultrawash -> upgrade to ultrawash plus
  else if (containsDish && !constainsUltrawashPlus) {
    return ultrawashPlusUpgradeAd;
  }

  // boxes does not contain ultrawash -> Add ultrawash plus
  else if (!containsDish && !constainsUltrawashPlus) {
    return addUltrawashPlusAd;
  } else return null;
};
